function AppToast({ show, type = 'success', message, onClose }) {
  if (!show) return null;
  const icon =
    type === 'success' ? 'bi-check-circle-fill' :
    type === 'warning' ? 'bi-exclamation-triangle-fill' :
                         'bi-exclamation-circle-fill';
  return (
    <div className={`app-toast app-toast--${type}`}>
      <i className={`bi ${icon}`}></i>
      {message}
      <button className="app-toast-close" onClick={onClose}>
        <i className="bi bi-x"></i>
      </button>
    </div>
  );
}

export default AppToast;
